export enum SortOrder {
  ASCENDING = 'asc',
  DESCENDING = 'desc',
}
